module.exports = __webpack_public_path__ + "media/img/vca/nome3-14742557d07d6d6131857d76212ec9af.png";